'use strict'

angular.module('webremote.module.ondemand', []).controller('overviewController', function ($scope, objectManagerService, onDemandRouterService) {
  $scope.searchText = ''
  $scope.om = objectManagerService
  $scope.onDemandRouterService = onDemandRouterService
})
